import type {
  NotificationMarkAllAsReadResponseType,
  NotificationMarkAllAsReadRequestType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import {
  apiV2AssertResponse,
  apiV2Request,
  hasBusinessMembership,
} from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useNotificationMarkAllAsRead = () => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();
  const canMarkAsRead = hasBusinessMembership({ user, business });

  const mutation = useMutation({
    mutationFn: async (data: NotificationMarkAllAsReadRequestType) => {
      // Mutations have no enabled option; protect every caller, including effects.
      if (!canMarkAsRead) return { markedCount: 0 };
      return apiV2Request({
        user,
        business,
        method: "post",
        path: `notifications/mark-all-read`,
        data,
      }).then(
        (data) =>
          apiV2AssertResponse(data)
            .data as NotificationMarkAllAsReadResponseType,
      );
    },

    onSuccess: () => {
      if (!canMarkAsRead) return;
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.Notifications],
      });
    },
  });
  return { ...mutation, canMarkAsRead };
};
